import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import cn from 'classnames';
import Label from '../InputLabel/InputLabel';
import styles from '../TextInput/TextInput.module.scss';
import ErrorInput from '../InputError/InputError';
const SelectInput = ({ label, field, form, options, className, name, onChange, placeholder }) => {
    const [focus, setFocus] = useState(!!field.value);
    useEffect(() => {
        if (field.value !== '') {
            setFocus(true);
        }
    }, [field.value]);
    const customStyles = {
        control: (defaultStyles, state) => (Object.assign(Object.assign({}, defaultStyles), { boxShadow: state.isFocused ? '0px 4px 12px rgba(31, 121, 245, 0.12)' : 0, backgroundColor: 'var(--main-background-header)', maxHeight: '6rem', borderColor: state.isFocused ? '#a6865b' : 'var(--line-color)', '&:hover': {
                borderColor: '#a6865b'
            } })),
        menu: (defaultStyles) => (Object.assign(Object.assign({}, defaultStyles), { zIndex: 1000, backgroundColor: 'var(--main-background-header)', '& .css-pep2w9-option': {
                backgroundColor: 'var(--main-background-header)'
            } })),
        option: (defaultStyles) => (Object.assign(Object.assign({}, defaultStyles), { color: 'var(--main-color)', '&:hover': {
                backgroundColor: 'var(--line-color)'
            }, '&:focus': {
                backgroundColor: 'var(--line-color)'
            }, '&:active': {
                backgroundColor: 'var(--line-color)'
            } })),
        valueContainer: (provided) => (Object.assign(Object.assign({}, provided), { maxHeight: '6rem', '& .css-6j8wv5-Input': {
                maxHeight: '6rem',
                padding: 0,
                margin: 0,
                color: 'var(--main-color)'
            } })),
        indicatorSeparator: (provided) => (Object.assign(Object.assign({}, provided), { display: 'none' })),
        singleValue: (provided) => (Object.assign(Object.assign({}, provided), { fontFamily: 'urbanist', color: 'var(--main-color)' }))
    };
    return (_jsxs("div", Object.assign({ className: cn(styles.wrapper, className) }, { children: [label && _jsx(Label, Object.assign({ className: styles.label }, { children: label })), _jsxs("div", Object.assign({ className: cn(styles.element, focus && styles['isFocused'], form.touched[field.name] && form.errors[field.name] && styles['isActive']) }, { children: [' ', options && (_jsx(Select, { options: options, className: cn(styles.select), onBlur: (e) => {
                            field.onBlur(e);
                            field.value === '' && setFocus(false);
                        }, name: name ? name : field.name, value: options ? options.find((option) => option.value === field.value) : '', onChange: onChange, styles: customStyles, placeholder: placeholder, onFocus: () => setFocus(true) }))] })), form.touched[field.name] && form.errors[field.name] && (_jsx(ErrorInput, { errors: form.errors, inputName: field.name }))] })));
};
export default SelectInput;
